import StokTerbaru from "./StokTerbaru"

export default StokTerbaru
